import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  deleteTodo,
  editTodoTitle,
  checkTodo,
  toggleEdit,
} from '../slices/todoSlice'
import { showAlert } from '../slices/alertSlice'

const List = () => {
  const dispatch = useDispatch()
  const list = useSelector((state) => state.todos.todoList)

  const [editInputName, setEditInputName] = useState('')
  const [isEdit, setisEdit] = useState(false)

  const deleteItem = (id) => {
    dispatch(deleteTodo(id))
    dispatch(
      showAlert({
        isVisible: true,
        type: 'danger',
        title: 'Item deleted',
      })
    )
  }

  const editItemTitle = (id) => {
    if (editInputName) {
      dispatch(editTodoTitle({ id: id, title: editInputName }))
      dispatch(
        showAlert({
          isVisible: true,
          type: 'success',
          title: 'Item updated',
        })
      )
      setEditInputName('')
      setisEdit(false)
    } else {
      dispatch(
        showAlert({
          isVisible: true,
          type: 'danger',
          title: 'Please enter a value',
        })
      )
    }
  }

  const setEditing = (id, title) => {
    setisEdit((prev) => !prev)
    setEditInputName(title)
    dispatch(toggleEdit(id))
  }

  return (
    <div className={`todo-list ${isEdit && 'edit-mode-on'}`}>
      {list.map((todo) => {
        return (
          <div
            key={todo.id}
            className={`todo-item ${todo.checked && 'checked'} ${
              todo.editing && 'editing-item'
            }`}
          >
            {todo.editing ? (
              <div className='todo-edit-input'>
                <input
                  type='text'
                  value={editInputName}
                  onChange={(e) => setEditInputName(e.target.value)}
                />
              </div>
            ) : (
              <>
                <button
                  type='button'
                  className='todo-item-check-btn'
                  onClick={() => dispatch(checkTodo(todo.id))}
                >
                  <svg
                    stroke='currentColor'
                    fill='currentColor'
                    strokeWidth='0'
                    height='1em'
                    width='1em'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 512 512'
                  >
                    <path
                      fill='currentColor'
                      d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'
                    ></path>
                  </svg>
                </button>
                <div className='todo-item-title'>
                  <div>{todo.title}</div>
                </div>
              </>
            )}

            <div className='todo-item-buttons'>
              {todo.editing ? (
                <>
                  <button
                    type='button'
                    className='todo-item-submit'
                    onClick={() => editItemTitle(todo.id)}
                  >
                    Update
                  </button>
                  <button
                    type='button'
                    className='todo-item-cancel-edit'
                    onClick={() => setEditing(todo.id)}
                  >
                    &times;
                  </button>
                </>
              ) : (
                <>
                  <button
                    type='button'
                    className={`todo-item-edit ${todo.checked && 'hidden'}`}
                    onClick={() => setEditing(todo.id, todo.title)}
                  >
                    <svg
                      stroke='currentColor'
                      fill='currentColor'
                      strokeWidth='0'
                      viewBox='0 0 576 512'
                      height='1em'
                      width='1em'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path d='M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z'></path>
                    </svg>
                  </button>
                  <button
                    type='button'
                    className='todo-item-delete'
                    onClick={() => deleteItem(todo.id)}
                  >
                    <svg
                      stroke='currentColor'
                      fill='currentColor'
                      strokeWidth='0'
                      viewBox='0 0 448 512'
                      height='1em'
                      width='1em'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path d='M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z'></path>
                    </svg>
                  </button>
                </>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default List
